<template>
  <el-container class="curri_content">
    <el-header>
      <index-header></index-header>
    </el-header>
    <el-main>
      <div class="mainContent">
        <p @click="back()" style="margin-bottom:10px;"><i class="icon el-icon-arrow-left"></i>{{$t('global.backToCourse')}}</p>
        <div class="main-arrow">
          <h3 class="font_36_reg">{{$t('course.title')}}</h3>
          <div class="main-info">
            <div class="select-part">
              <el-select v-model="subData" @change="search" collapse-tags placeholder="Select a Subject">
                  <el-option v-for="item in getSub"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">{{item.title}}</el-option>
              </el-select>
            </div>
            <div class="courseInfo">
              <div class="courseName flex_center">
                <img :src="subInfo.img" />
                <p class="font_24_bold">{{subInfo.title}}</p>
              </div>
              <div class="courseDesc">
                <p class="font_24_reg">{{$t('course.subjectDescription')}}:</p>
                <p class="font_18_reg">{{subInfo.description}}</p>
              </div>
              <div class="courseLevel">
                <p class="font_24_reg">{{$t('course.levels')}}:</p>
                <div class="levelList">
                  <div>
                    <span @click="showLevel(item)" v-for="(item, i) in getlevels"  :key="i" :class="item.selected?'is-active':''">{{item.title}}<i></i></span>
                  </div>
                </div>
                <!-- <el-tabs v-model="activeTitle" type="card" @tab-click="handleClick">
                  <el-tab-pane label="Scheduled Lesson" name="schedule" class="schedule_">
                    <span slot="label">
                      <span class="span-box">
                        <span><img src="../assets/yellow_bg.svg" /></span>
                      </span>
                    </span>
                    <my-scheduled :dataschedule="scheduleData"></my-scheduled>
                  </el-tab-pane>
                  <el-tab-pane label="Course" name="course" class="course_">
                    <my-course :datacourse="courseData"></my-course>
                  </el-tab-pane>
                  <el-tab-pane label="Completed Lesson" name="lesson">
                    <past-lesson :datacourse="lessonData"></past-lesson>
                  </el-tab-pane>
                </el-tabs> -->
                <div class="levelInfo">
                  <h3 class="font_24_reg">{{$t('course.best')}} {{levelInfo.age_range_start}} - {{levelInfo.age_range_end}} {{$t('course.yearold')}}</h3>
                  <p class="font_18_reg">{{levelInfo.description}}</p>
                </div>
              </div>
              <div class="lessonTopic">
                <p class="font_24_reg">{{$t('course.lessonTopic')}}</p>
                <p class="font_24_reg">({{$t('course.totalLesson')}} {{lessonTotal}})</p>
                <div class="levelTopicList">
                  <div v-for="(item, i) in getTopics"  :key="i">
                    <p class="topicTitle font_18_reg"><b v-html="i<9?'0'+(i+1):i+1"></b><span>{{item.lesson_topic?item.lesson_topic:'-'}}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <index-footer></index-footer>
    </el-footer>
  </el-container>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
import IndexHeader from './views/header'
import IndexFooter from './views/footer'
export default {
  components: {
    IndexHeader,
    IndexFooter
  },
  name: 'curriculum',
  data () {
    return {
      courseData: [],
      getlevels: [],
      getSub: [],
      subData: '',
      subInfo: {},
      levelInfo: {},
      getTopics: [],
      lessonTotal: 0
    }
  },
  // watch:{
  //   //监控列表总数据量的变化
  //   datacourse(newVal,oldVal){
  //       //当总数据量变化时，重新计算分页的数量（需要显示多少页）
  //       this.data =newVal;
  //   }
  // },
  created () {
    this.courseData = getStore(keys.currentCourse)
    this.subData = this.courseData.subject_id
    this.getSubjects()
  },
  methods: {
    back () {
      this.$router.push({ path: '/index?type=1' })
    },
    getSubjects () {
      this.$http.get('/api/edu/subjects').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.getSub = res.data.data
          this.getSub.map((item, i) => {
            if (item.id == this.courseData.subject_id) {
              this.subInfo = item
            }
          })

          this.getlevelsData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    search (id) {
      this.getSub.map((item, i) => {
        if (item.id == id) {
          this.subInfo = item
        }
      })
      this.getlevelsData()
    },
    getlevelsData () {
      this.$http.get('/api/edu/subjects-' + this.subInfo.id + '/levels').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.getlevels = res.data.data
          this.getlevels.map((item, i) => {
            if (i == 0) {
              item.selected = true
            } else {
              item.selected = false
            }
          })
          this.showLevel(this.getlevels[0])
          // store.setChildList(res.data.data);
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    showLevel (levelItem) {
      this.getlevels.map((item) => {
        if (item.id == levelItem.id) {
          item.selected = true
          this.levelInfo = item
          this.getTopicsData()
        } else {
          item.selected = false
        }
      })
      this.$forceUpdate()
    },
    getTopicsData () {
      this.$http.get('/api/getLessonTopicForSubject?subject_id=' + this.subInfo.id + '&level_id=' + this.levelInfo.id).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.getTopics = res.data.data
          this.lessonTotal = res.data.total
          // this.getTopics.map((item,i)=>{
          //     if(i==0){
          //       item.selected = true;
          //     }else{
          //       item.selected = false;
          //     }
          // })
          // store.setChildList(res.data.data);
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  }
}
</script>

<style lang="less" scoped>
.curri_content{
  position: relative;
  .el-header{
    height: 88px!important;
    background: rgba(53,54,67,0.90);
    width: 100%;
    padding:0;
  }
  .el-main{
    overflow: inherit;
    padding:0;
    margin-bottom:254px;
    z-index:22;
    .mainContent{
      width:1200px;
      margin:25px auto 54px;
      .main-arrow{
        background: #FFFFFF;
        border: 1px solid #FFD1C6;
        border-radius: 5px;
        padding:30px;
        .main-info{
          padding:20px 30px;
          .select-part{
            background: rgba(235, 233, 241, 0.5);
            border-radius: 5px;
            padding:18px 28px;
            .el-select {
              width: 343px;
              height: 40px;
              background: none;
              border-bottom: 1px solid #6B6B6B;
              color: #353643;
              /deep/ .el-input{
                height:40px;
                .el-input__inner{
                  width:330px;
                  height: 100%;
                  background: none;
                  border:none;
                  color: #353643;
                  font-family: Sofia Pro-Regular;
                }
                .el-input__suffix{
                  right: 15px;
                }
                .el-select__caret{
                  color: #6e6b7b;
                }
              }
            }
          }
          .courseInfo{
            margin-top:40px;
            .courseName{
              margin-bottom:20px;
              img{
                width:80px;
                height: 80px;
                margin-right:30px;
              }
            }
            .courseDesc{
              margin-bottom:30px;
              p{
                line-height: 24px;
                margin-bottom: 10px;
              }
            }
            .courseLevel{
              .levelList{
                display: flex;
                margin-top:20px;
                span{
                  height: 40px;
                  line-height: 40px;
                  text-align: center;
                  background: #fff;
                  border-radius: 30px;
                  border:none;
                  border-bottom:none;
                  font-size: 16px;
                  color: #000;
                  margin-left:4px;
                  margin-right:16px;
                  font-family: Sofia Pro-Regular;
                  position: relative;
                  display: inline-block;
                  padding:0 40px;
                  &.is-active{
                    border-radius: 30px;
                    border: 1px solid #ffd1c6;
                    background-color: #FFB800;
                    color: #000;
                    border:none;
                    border-bottom:none;
                    font-family: Sofia Pro-Regular;
                    i{
                      width:21px;
                      height: 16px;
                      position: absolute;
                      bottom:-16px;
                      left:50%-10px;
                      background: url("../assets/yellow_bg.svg") no-repeat;
                    }
                  }
                }
              }
              .levelInfo{
                background: #FFFFFF;
                border: 1px solid #A5A5A5;
                border-radius: 5px;
                padding:40px;
                margin-top:28px;
                h3{
                  margin-bottom:10px;
                }
                p{
                  line-height: 26px;
                }
              }
            }
            .lessonTopic{
              margin-top:50px;
              >p{
                margin-top:24px;
              }
              .levelTopicList{
                display: flex;
                flex-wrap: wrap;
                margin-top:20px;
                >div{
                  width:475px;
                  margin:15px 0;
                  margin-right:20px;
                  .topicTitle{
                    b{
                      width:50px;
                      display: inline-block;
                      margin-right:30px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .el-footer{
    width:100%;
    height:inherit!important;
    padding:0;
    position: absolute;
    bottom:0;
  }

  // tab切换
  /deep/ .el-tabs--card{
    .el-tabs__header{
      border:none;
      margin: 0;
      .el-tabs__nav-wrap{
        margin-bottom:0;
      }
      .el-tabs__nav{
        border:none;
        border-radius: 0;
        .el-tabs__item{
          background: #fff;
          border-radius: 30px;
          border:none;
          border-bottom:none;
          font-size: 16px;
          color: #000;
          margin-left:4px;
          margin-right:16px;
          font-family: Sofia Pro-Regular;
          &.is-active{
            border-radius: 30px;
            border: 1px solid #ffd1c6;
            background-color: #FFB800;
            background-image: url("../assets/yellow_bg.svg");
            color: #000;
            border:none;
            border-bottom:none;
            font-family: Sofia Pro-Regular;
          }
        }
      }
    }
    .el-tabs__content{
      // background: #fff;
      // border: 1px solid #ffd1c6;
      // border-radius: 6px;
      .el-tab-pane{
        margin:20px 13px 55px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/curriculum.vue